import { toast } from '@/components/ui/use-toast';

export function isMobileDevice(): boolean {
	return (
		/Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent) &&
		('ontouchstart' in window || navigator.maxTouchPoints > 0)
	);
}

export async function shareLink({
	url,
	title,
	message,
	skipMobileCheck,
	onDesktopShare,
}: {
	url: string;
	title?: string;
	message?: string;
	skipMobileCheck?: boolean;
	onDesktopShare?: (url: string, message: string) => void;
}): Promise<void> {
	const legacyMessage = message ?? title ?? '';

	if ((skipMobileCheck || isMobileDevice()) && navigator.share) {
		try {
			const shareData: { url: string; title?: string; text?: string } = { url };
			if (legacyMessage) {
				shareData.text = legacyMessage;
			}
			// Only set title when it differs from text, else it shows twice on some targets.
			if (title && title !== legacyMessage) {
				shareData.title = title;
			}
			await navigator.share(shareData);
		} catch (error) {
			if ((error as Error).name !== 'AbortError') {
				console.error('Share failed:', error);
			}
		}
	} else if (onDesktopShare) {
		onDesktopShare(url, legacyMessage);
	} else {
		try {
			await navigator.clipboard.writeText(url);
			toast({ title: 'Success', description: 'Link copied to clipboard' });
		} catch (error) {
			console.error('Share failed:', error);
			toast({ variant: 'destructive', title: 'Error', description: 'Failed to copy link' });
		}
	}
}
